import { useState, useEffect } from 'react'
import { breakpointPx } from './ContentHelper'

const useMedia = (values, defaultValue, queries = null) => {
  const [value, setMatch] = useState(defaultValue)

  const match = () => {
    const definedQueries = queries || [
      `(min-width: ${breakpointPx.LARGE}px)`,
      `(min-width: ${breakpointPx.MEDIUM}px)`,
      `(min-width: ${breakpointPx.SMALL}px)`,
      `(min-width: 0)`,
    ]

    const matchingQuery = definedQueries.findIndex((item) => window.matchMedia(item).matches)
    return values[matchingQuery] || defaultValue
  }

  useEffect(() => {
    const handler = () => setMatch(match)
    window.addEventListener('resize', handler)
    handler()
    setMatch(match)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return value
}

export default useMedia
